import { useEffect, useState } from "react"
import { TaxTerm } from "../../helpers/interfaces"
import { FormEditMode } from "../../helpers/constants"
import { createTaxTerm, updateTaxTerm } from "../../apiServices/CTBMappingKeysApi"
import CustomDialog from "../CustomDialog"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"
import { CustomTextField } from "../../layouts/themes"

interface Props {
    setTaxTerm:React.Dispatch<React.SetStateAction<TaxTerm[]>>
    taxTerm: TaxTerm[]
    openTaxTermForm:boolean
    setFormEditMode:  React.Dispatch<React.SetStateAction<number>>
    setOpenTaxTermForm:React.Dispatch<React.SetStateAction<boolean>>
    taxTermToEdit:string
    taxTermEditMode:number
}
function CreateEditTaxTerm(props: Props) {
    const [taxTermName, setTaxTermName] = useState<string>("");
    
    useEffect(() => {
        if (props.taxTermEditMode === FormEditMode.EDIT) {
            var taxName = props.taxTerm.find(e => e.id === props.taxTermToEdit)
            if (!taxName) return
            setTaxTermName(taxName.name)
           
        }
    }, [props.taxTerm, props.taxTermToEdit, props.taxTermEditMode])

    function createNewTaxTerm() {
        createTaxTerm(taxTermName).then(_tax=> {
            props.setOpenTaxTermForm(false);
            props.setTaxTerm(tax => [...tax, _tax])
            
        })
    }
    function updateNewTaxTerm() {
        updateTaxTerm(props.taxTermToEdit, taxTermName).then(result => {
            props.setOpenTaxTermForm(false);
            props.setTaxTerm(tax => tax.map(a=> a.id === props.taxTermToEdit ? result: a))
           
        })
    }
    return (
        <>
        <CustomDialog dialogTitle={props.taxTermEditMode === FormEditMode.CREATE ? 'Add New Tax Term ' : 'Update Tax Term '} setOpenDialog={props.setOpenTaxTermForm} openDialog={props.openTaxTermForm}>
            <form>
                <div >
                    <label className='title-label'>Tax Term Name <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="Tax Term Name" value={taxTermName} onChange={(e) => setTaxTermName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={!taxTermName} variant="contained" color='secondary' onClick={props.taxTermEditMode === FormEditMode.CREATE ? createNewTaxTerm : updateNewTaxTerm} >
                        <Add />&nbsp; {props.taxTermEditMode === FormEditMode.CREATE ? 'Add New Tax Term' : 'Update Tax Term'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditTaxTerm